import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';

ChartJS.register(ArcElement, Tooltip);

interface KpiScoreChartProps {
  score: number;
}

const KpiScoreChart: React.FC<KpiScoreChartProps> = ({ score }) => {
  const getColor = (s: number) => {
    if (s >= 8) return '#4ade80'; // green-400
    if (s >= 5) return '#facc15'; // yellow-400
    return '#f87171'; // red-400
  };

  const chartColor = getColor(score);
  const remainingColor = '#374151'; // gray-700

  const data = {
    datasets: [
      {
        data: [score, 10 - score],
        backgroundColor: [chartColor, remainingColor],
        borderColor: ['#111827', '#111827'], // bg-gray-900 for a border effect
        borderWidth: 2,
        circumference: 180,
        rotation: 270,
        cutout: '70%',
      },
    ],
  };

  const options = {
    plugins: {
      tooltip: {
        enabled: false,
      },
    },
    maintainAspectRatio: false,
    animation: {
        animateRotate: true,
        duration: 1000,
    },
  };

  return (
    <div className="relative w-24 h-24 flex-shrink-0" title={`Score: ${score}/10`}>
      <Doughnut data={data} options={options} />
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none mt-[-10px]">
        <span className="text-3xl font-bold" style={{ color: chartColor }}>
          {score}
        </span>
        <span className="text-xs text-gray-400 -mt-1">/ 10</span>
      </div>
    </div>
  );
};

export default KpiScoreChart;
